import { formRules } from "../../../config/validations/formRules";

import { validations } from "../../../config/validations/validations";


export const rules: any = {
    first_name: () => formRules.first_name(),
    last_name: () => formRules.last_name(),
    email: (field?: string) => [
		validations.required.text(field),
		validations.email(field),
	],
    company: (field?: string) => [
        validations.required.text(field),
    ],
    city: (field?: string) => [
        validations.required.text(field),
    ],
    state: (field?: string) => [
        validations.required.text(field),
    ],
    lead_source: () => [
       validations.required.select()
    ],
    mobile: (field?:any) => [
		validations.required.text(field),
		validations.pattern.phone,
		validations.min.number(10),
		validations.max.number(20)
	],
    linkedIn: (field?: string) => [
        validations.required.text(field),
    ],
    
};